// First-party visitor id + session + ad-source attribution (no third-party, no cookies).

const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes of inactivity ends a session

export function getVisitorId() {
  try {
    let id = localStorage.getItem("cbs_visitor_id");
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random();
      localStorage.setItem("cbs_visitor_id", id);
    }
    return id;
  } catch {
    return "anon";
  }
}

// Returns the current session id and whether THIS call is the first hit of a new
// session (an "entry"). A session resets after 30 minutes of inactivity.
export function getSessionInfo() {
  try {
    const now = Date.now();
    const ts = parseInt(localStorage.getItem("cbs_session_ts") || "0", 10);
    let sid = localStorage.getItem("cbs_session_id");
    let isEntry = false;
    if (!sid || !ts || now - ts > SESSION_TIMEOUT_MS) {
      sid = crypto.randomUUID ? crypto.randomUUID() : String(now) + Math.random();
      localStorage.setItem("cbs_session_id", sid);
      isEntry = true;
    }
    localStorage.setItem("cbs_session_ts", String(now));
    return { session_id: sid, is_entry: isEntry };
  } catch {
    return { session_id: "anon", is_entry: false };
  }
}

// Read UTM params from the current URL.
export function readUtmFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
    };
  } catch {
    return { utm_source: "", utm_medium: "", utm_campaign: "" };
  }
}

// Persist the visitor's FIRST-touch attribution (landing page + source). Called on each
// page load; only writes the first time so the original ad source sticks through checkout.
export function captureFirstTouch(path) {
  try {
    const utm = readUtmFromUrl();
    if (!localStorage.getItem("cbs_attribution")) {
      localStorage.setItem("cbs_attribution", JSON.stringify({ landing: path, ...utm }));
    }
  } catch { /* ignore */ }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem("cbs_attribution") || "{}");
  } catch {
    return {};
  }
}
